import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Active from './activecourses';
import Favorite from './completedcourses';
import Launched from './launchedcourses';
import '../../../../../../styles/learnersDashboard/courses.css';

const Courses = () => {
    const [activeLink, setActiveLink] = useState('active');
    const [favoriteLink, setfavoriteLink] = useState(null);
    const [LaunchedLink, setlaunchedLink] = useState(null);


    const handleLinkClick = (linkName) => {
        setActiveLink(linkName);
        setfavoriteLink(linkName);
        setlaunchedLink(linkName);
    };

    return (
        <div className='mylearningpaths'>
        <div className='courses'>
            <Link
                className={activeLink === 'active' ? 'active-link' : ''}
                onClick={() => handleLinkClick('active')}
            >
                <h1 className='active'>My Active Courses</h1>
            </Link>
            <Link
                className={favoriteLink === 'favorite' ? 'favorite-link' : ''}
                onClick={() => handleLinkClick('favorite')}
            >
                <h1 className='favorite'>Completed Courses</h1>
            </Link>
            <Link
                className={LaunchedLink === 'launched' ? 'launched-link' : ''}
                onClick={() => handleLinkClick('launched')}
            >
                <h1 className='launched'>Newly Launched Courses</h1>
            </Link>
            </div>
        <div>
        <div className='myactive'>{activeLink === 'active' && <Active />}</div>
        <div className='myfavorite'>{favoriteLink === 'favorite' && <Favorite />}</div>
        <div className='mylaunched'>{LaunchedLink === 'launched' && <Launched />}</div>
        </div>
        </div>
    );
};

export default Courses;
